<template>
    <div>
    <div v-if="isLoading" class="loading">Loading&#8230;</div> 

<div id="myModalContact" class="modal">
  <div class="modal-background"></div>
  <div class="modal-content" style="width:60%; height:85%;">
    <div  class="box has-background-grey">
        <Contact 
        :data_students="data_contact"
        :student_cnt="data_contact.length"
        @emit_close_modal="close_contact_modal"
        >   </Contact>
    </div>
  </div>
</div>

<div id="myModalPai" class="modal">
  <div class="modal-background isLink" @click="modal_close()"></div>
  <div class="modal-content" style="width: 70%">
    <div  class="box">

    <PaymentsStudent v-if="student_id"  :studentID="student_id" showHeader='YES' :key="student_id" 
        @modal_close="modal_close"
    ></PaymentsStudent> 

    </div>
  </div>
  <button @click="modal_close()" class="modal-close"></button>
</div>
<!-- END MODAL !!!!!!!!!!!!!!!!!!!!!!!!!1  -->





<div class="columns is-vcentered is-gapless is-mobile has-background-grey-dark" style="">
    <div class="column is-1">
        <button @click="sortNav()" class="button is-fullwidth has-background-dark has-text-white">
            <span class="icon is-small has-text-left"><i class="fas fa-angle-double-right"></i></span>     
        </button> 
    </div>



</div>

<!--  -->




<div id="mySidebar" class="sidebar has-background-grey-dark" style="margin-top:3.7em;">




<!-- DISPLAY VIEW  -->
<div class="box is-radiusless has-background-grey-dark" style="margin-bottom:.4em;"> 

<div class="columns is-gapless is-multiline mt-4">

    <div class="column is-10 is-size-3 has-text-weight-bold mt-2 has-text-grey-lighter">
        <span v-if="paiment_view=='IMPOT'">Impot </span>
        <span v-else>Paiements </span>
       
    </div>

    <div class="column is-2">
        <button @click="sortNav()" class="button is-fullwidth has-background-dark has-text-white">
            <span class="icon is-small has-text-left"><i class="fas fa-angle-double-left"></i></span>     
        </button> 
    </div>






<div class="column is-12 has-tooltip-bottom has-tooltip-warning" style="" data-tooltip="Change Date Range">
<div class="columns is-multiline is-gapless" >
<div class="column is-1"></div>
    
    <div v-if="paiment_view=='IMPOT'" @click="show_dt_change=!show_dt_change" class="column is-10 box isLink has-background-info has-text-white is-size-4 has-text-centered has-text-weight-bold">
         2021
    </div>

    <div v-else @click="show_dt_change=!show_dt_change" class="column is-10 box isLink has-background-info has-text-white is-size-4 has-text-centered has-text-weight-bold">
         {{ dtStart | moment("MMM DD")}} - {{dtEnd | moment("MMM DD") }}
    </div>


<div class="column is-1"></div>
</div></div> 

<!-- CALENDAR DATA CHANGE  -->
<div v-if="show_dt_change" class="column is-12 mt-3">
<div class="columns is-gapless is-multiline">
<div class="column is-6" style="">
<div class="columns is-gapless is-multiline">
<div class="column is-12 isLabel">Date de début</div>
<div class="column is-12">
        <flat-pickr 
            v-model="dtStart"
            class="input is-size-6 has-text-weight-bold has-text-centered"
            :config="config"
            name="dtStart">
        </flat-pickr>  
</div></div></div>
<div class="column is-6" style="">
<div class="columns is-gapless is-multiline">
<div class="column is-12 isLabel">Date de fin</div>
<div class="column is-12">
        <flat-pickr 
            v-model="dtEnd"
            class="input is-size-6 has-text-weight-bold has-text-centered"
            :config="config"
            name="dtStart">
        </flat-pickr>  
</div></div></div>
<div class="column is-12 mt-2">
    <button @click="get_paiement_info()" class="button is-small is-fullwidth has-background-success has-text-white">
        <span class="icon is-small has-text-left"><i class="fas fa-plus"></i></span>&nbsp;&nbsp;&nbsp;&nbsp;SET DATES     
    </button> 
</div></div></div>
<!-- END CALENDAR DATA CHANGE  -->

<div class="column is-12 mt-6" style="">
<div class="columns is-multiline is-gapless box has-background-grey">
<div class="column is-12 has-text-white">Filtres</div>

    <!-- <div class="column is-10 has-text-centered has-text-weight-bold">
            <p class="control has-icons-left"><input  v-model="search" v-on:keyup.enter="sort_search()" class="input is-fullwidth" type="text" placeholder="search">
            <span class="icon is-small is-left"><i class="fas fa-search" aria-hidden="true"></i></span></p>
    </div>
    <div @click="clear_search_search()" class="column colBorderThin is-2 isLink has-text-centered" style="">
        <span class="icon is-small has-text-light mt-3"><i class="fas fa-minus-circle"></i></span>
    </div> -->
<!-- @change="sort_this_shit()" -->
<div class="column is-1 is-size-7 has-text-light mt-2"> E. </div> 
<div class="column is-9"> 
        <div class="select is-fullwidth">
        <select v-model="filter_etud" >
            <option value=""></option>
            <option v-for="(data,index) in data_filter_etud" :value="data.student_ID"  :key="index" >{{data.student_lNAME}}, {{data.student_fNAME}}</option>
        </select>
</div></div>
<div @click="clear_search_group()" class="column colBorderThin is-2 isLink has-text-centered" style="">
    <span class="icon is-small has-text-light mt-3"><i class="fas fa-minus-circle"></i></span>
</div>

<div class="column is-1 is-size-7 has-text-light mt-2"> G. </div> 
<div class="column is-9"> 
        <div class="select is-fullwidth">
        <select v-model="filter_grp">
            <option value=""></option>
            <option v-for="(data,index) in data_filter_grp" :value="data"  :key="index" >{{ data }}</option>
        </select>
</div></div>
<div @click="clear_search_cour()" class="column colBorderThin is-2 isLink has-text-centered" style="">
    <span class="icon is-small has-text-light mt-3"><i class="fas fa-minus-circle"></i></span>
</div>


</div></div>
<!-- end filter -->


</div>  <!-- end main columns -->
</div>  <!-- end box -->
</div>
<!-- END SIDEBAR  -->

<div id="mainContent">
<div id="printME">
<!-- -->


<div class="columns is-gapless has-background-grey-dark colBorderBottomThin" style="margin-top:-4em;">
    
<div v-if="paiment_view=='IMPOT'" class="column is-9 has-text-white has-text-right has-text-weight-bold is-size-5"> 
<div class="columns is-gapless">

    <div class="column is-2">
    <!-- NAVIGATION BUTTONS!! -->
    <div class="columns has-background-info-light is-gapless is-multiline" >
    <div :disabled="page_offset==0" @click="pagination_previous()" class="column is-3"><button class="button is-fullwidth has-text-info"><span class="icon"><i class="fas fa-chevron-left"></i></span> </button></div>
    <div class="column is-6 is-size-6 has-text-centered has-text-weight-bold mt-2">{{page_string}}</div>
    <div @click="pagination_next()" class="column is-3"><button class="button is-fullwidth has-text-info"><span class="icon"><i class="fas fa-chevron-right"></i></span> </button></div>
    </div>
    <!-- ** END ** NAVIGATION BUTTONS!! -->
    </div>


    <div class="column is-2 has-text-right has-text-weight is-size-5 colBorderThin"><span class="is-size-7 has-text-link">Cnt:</span> {{impot_head_cnt}}&nbsp;</div>
    <div class="column is-2 has-text-right has-text-weight is-size-5 colBorderThin"><span class="is-size-7 has-text-link">Amt:</span>{{impot_head_amt.toFixed(2)}}&nbsp;</div>

    <div class="column is-2 has-text-right has-text-weight is-size-5 colBorderThin"><span class="is-size-7 has-text-link">Sel:</span>{{impot_head_cnt_select}}&nbsp;</div>
    <div class="column is-2 has-text-right has-text-weight is-size-5 colBorderThin"><span class="is-size-7 has-text-link">Qc:</span>{{impot_head_amt_qc.toFixed(2)}}&nbsp;</div>
    <div class="column is-2 has-text-right has-text-weight is-size-5 colBorderThin"><span class="is-size-7 has-text-link">Can:</span>{{impot_head_amt_can.toFixed(2)}}&nbsp;</div>


</div></div>    
    
<div v-else class="column is-8 mt-3 has-text-white has-text-right has-text-weight-bold is-size-5"> 
    <span class="is-size-7">Total:&nbsp;&nbsp;</span>{{format_money(pay_total,"$")}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    <span class="is-size-7">Recu:&nbsp;&nbsp;</span>{{format_money(pay_recu,"$")}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    <span class="is-size-7">Solde:&nbsp;&nbsp;</span>{{format_money(pay_solde,"$")}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</div>
<!-- END CUSTOM MENU  -->

  <div class="column has-text-centered is-1 has-text-right has-text-weight-light is-size-6" style="margin-bottom:-.2em;"> 
      <button v-print="'#printME'"  class="button is-fullwidth has-background-info-light"><span class="icon is-small has-text-grey"> <i class="fas fa-print"></i> </span></button>
  </div>


    <div class="column is-1 has-tooltip-top has-tooltip-warning" data-tooltip="Calendar View">
        <button @click="paiment_view='CALENDAR'" class="button is-fullwidth has-background-grey has-text-white">
            <span class="icon is-small has-text-left"><i class="fas fa-calendar-week"></i> &nbsp;&nbsp;CAL.</span>     
        </button> 
    </div>

    <div class="column is-1 has-tooltip-top has-tooltip-warning" data-tooltip="List View">
        <button  @click="paiment_view='LIST'" class="button is-fullwidth has-background-grey has-text-white">
            <span class="icon is-small has-text-left"><i class="fas fa-list"></i> &nbsp;&nbsp;LIST</span>     
        </button> 
    </div>

    <div class="column is-1 has-tooltip-top has-tooltip-warning" data-tooltip="Impot View">
        <button @click="impot_go()" class="button is-fullwidth has-background-grey has-text-white">
            <span class="icon is-small has-text-left"><i class="fas fa-tenge"></i> &nbsp;&nbsp;IMPOT</span>     
        </button> 
    </div>
</div>
<!-- END HEADER  -->



<div v-if="paiment_view=='CALENDAR'">
<div class="columns is-multiline is-gapless" v-for="indexMain in data_days_calendar.length" :key="indexMain">       



<div class="column is-1">
    <div class="columns is-multiline is-gapless has-text-left has-text-weight-bold has-text-warning">
        <div class="column is-12 has-background-grey-dark">&nbsp;&nbsp;<span class="is-size-7">WK</span>  {{return_week_number(moment(data_days_calendar[indexMain-1][0].dt))}}
        
            <span @click="contact_click(data_days_calendar[indexMain-1][0].dt)" class="icon mt-1 is-small is-pulled-right has-text-warning has-tooltip-left has-tooltip-warning" data-tooltip="Send Message"><i class="fas fa-comment-alt"></i>&nbsp;&nbsp;</span>        
        
         <!-- v-if="contact_check(data_days_calendar[indexMain-1][1].dt)" -->
        
        </div>
        <div class="column is-12 has-background-white"> ---</div>
    </div>
</div>




<div class="column is-11">
<div class="columns is-gapless">

<div class="column is-2">
    <div class="columns is-gapless is-multiline">
        <div class="column is-12 colBorderThinRight has-text-centered has-text-weight-bold has-background-grey has-text-white">{{ moment(data_days_calendar[indexMain-1][0].dt).format('ddd-MMM DD') }} 
            <span @click="contact_click(data_days_calendar[indexMain-1][0].dt)" v-if="contact_check(data_days_calendar[indexMain-1][0].dt)" class="icon mt-1 is-small is-pulled-right has-text-warning has-tooltip-left has-tooltip-warning" data-tooltip="Send Message"><i class="fas fa-comment-alt"></i>&nbsp;&nbsp;</span>
        </div>

<div @click="payment_click(s_data.student_ID)" class="column is-12 isLink" v-for ="(s_data, index) in calendar_load_day(data_days_calendar[indexMain-1][0].dt)" :key="index">
    <div class="columns is-gapless colBorderBottomThin">
        <div class="column is-8 has-background-white is-size-7 has-text-weight-bold is-uppercase">&nbsp;{{s_data.student_lNAME}} <span class="doFontSmallest"> {{s_data.student_fNAME}} </span></div>
        <div class="column is-4 is-size-7 has-text-right has-text-weight-bold" :style="return_style_calendar_item(s_data.payment_Rec,s_data.payment_DueDate)">{{format_money(s_data.payment_Amount,'$')}} &nbsp;</div>
    </div>
</div>

    </div>
</div>

<div class="column is-2">
    <div class="columns is-gapless is-multiline">
        <div class="column is-12 colBorderThinRight has-text-centered has-text-weight-bold has-background-grey has-text-white">{{ moment(data_days_calendar[indexMain-1][1].dt).format('ddd-MMM DD') }} 
            <span @click="contact_click(data_days_calendar[indexMain-1][1].dt)" v-if="contact_check(data_days_calendar[indexMain-1][1].dt)" class="icon mt-1 is-small is-pulled-right has-text-warning has-tooltip-left has-tooltip-warning" data-tooltip="Send Message"><i class="fas fa-comment-alt"></i>&nbsp;&nbsp;</span>
        </div>

<div @click="payment_click(s_data.student_ID)" class="column is-12 isLink" v-for ="(s_data, index) in calendar_load_day(data_days_calendar[indexMain-1][1].dt)" :key="index">
    <div class="columns is-gapless colBorderBottomThin">
        <div class="column is-8 has-background-white is-size-7 has-text-weight-bold is-uppercase">&nbsp;{{s_data.student_lNAME}} <span class="doFontSmallest"> {{s_data.student_fNAME}} </span></div>
        <div class="column is-4 is-size-7 has-text-right has-text-weight-bold" :style="return_style_calendar_item(s_data.payment_Rec,s_data.payment_DueDate)">{{format_money(s_data.payment_Amount,'$')}} &nbsp;</div>
    </div>
</div>

    </div>
</div>

<div class="column is-2">
    <div class="columns is-gapless is-multiline">
        <div class="column is-12 colBorderThinRight has-text-centered has-text-weight-bold has-background-grey has-text-white">{{ moment(data_days_calendar[indexMain-1][2].dt).format('ddd-MMM DD') }} 
            <span @click="contact_click(data_days_calendar[indexMain-1][2].dt)" v-if="contact_check(data_days_calendar[indexMain-1][2].dt)" class="icon mt-1 is-small is-pulled-right has-text-warning has-tooltip-left has-tooltip-warning" data-tooltip="Send Message"><i class="fas fa-comment-alt"></i>&nbsp;&nbsp;</span>
        </div>

<div @click="payment_click(s_data.student_ID)" class="column is-12 isLink" v-for ="(s_data, index) in calendar_load_day(data_days_calendar[indexMain-1][2].dt)" :key="index">
    <div class="columns is-gapless colBorderBottomThin">
        <div class="column is-8 has-background-white is-size-7 has-text-weight-bold is-uppercase">&nbsp;{{s_data.student_lNAME}} <span class="doFontSmallest"> {{s_data.student_fNAME}} </span></div>
        <div class="column is-4 is-size-7 has-text-right has-text-weight-bold" :style="return_style_calendar_item(s_data.payment_Rec,s_data.payment_DueDate)">{{format_money(s_data.payment_Amount,'$')}} &nbsp;</div>
    </div>
</div>

    </div>
</div>

<div class="column is-2">
    <div class="columns is-gapless is-multiline">
        <div class="column is-12 colBorderThinRight has-text-centered has-text-weight-bold has-background-grey has-text-white">{{ moment(data_days_calendar[indexMain-1][3].dt).format('ddd-MMM DD') }} 
            <span @click="contact_click(data_days_calendar[indexMain-1][3].dt)" v-if="contact_check(data_days_calendar[indexMain-1][3].dt)" class="icon mt-1 is-small is-pulled-right has-text-warning has-tooltip-left has-tooltip-warning" data-tooltip="Send Message"><i class="fas fa-comment-alt"></i>&nbsp;&nbsp;</span>
        </div>

<div @click="payment_click(s_data.student_ID)" class="column is-12 isLink" v-for ="(s_data, index) in calendar_load_day(data_days_calendar[indexMain-1][3].dt)" :key="index">
    <div class="columns is-gapless colBorderBottomThin">
        <div class="column is-8 has-background-white is-size-7 has-text-weight-bold is-uppercase">&nbsp;{{s_data.student_lNAME}} <span class="doFontSmallest"> {{s_data.student_fNAME}} </span></div>
        <div class="column is-4 is-size-7 has-text-right has-text-weight-bold" :style="return_style_calendar_item(s_data.payment_Rec,s_data.payment_DueDate)">{{format_money(s_data.payment_Amount,'$')}} &nbsp;</div>
    </div>
</div>

    </div>
</div>

<div class="column is-2">
    <div class="columns is-gapless is-multiline">
        <div class="column is-12 colBorderThinRight has-text-centered has-text-weight-bold has-background-grey has-text-white">{{ moment(data_days_calendar[indexMain-1][4].dt).format('ddd-MMM DD') }} 
            <span @click="contact_click(data_days_calendar[indexMain-1][4].dt)" v-if="contact_check(data_days_calendar[indexMain-1][4].dt)" class="icon mt-1 is-small is-pulled-right has-text-warning has-tooltip-left has-tooltip-warning" data-tooltip="Send Message"><i class="fas fa-comment-alt"></i>&nbsp;&nbsp;</span>
        </div>

<div @click="payment_click(s_data.student_ID)" class="column is-12 isLink" v-for ="(s_data, index) in calendar_load_day(data_days_calendar[indexMain-1][4].dt)" :key="index">
    <div class="columns is-gapless colBorderBottomThin">
        <div class="column is-8 has-background-white is-size-7 has-text-weight-bold is-uppercase">&nbsp;{{s_data.student_lNAME}} <span class="doFontSmallest"> {{s_data.student_fNAME}} </span></div>
        <div class="column is-4 is-size-7 has-text-right has-text-weight-bold" :style="return_style_calendar_item(s_data.payment_Rec,s_data.payment_DueDate)">{{format_money(s_data.payment_Amount,'$')}} &nbsp;</div>
    </div>
</div>

    </div>
</div>

<div class="column is-1">
    <div class="columns is-gapless is-multiline">
        <div class="column is-12 colBorderThinRight has-text-centered has-text-weight-bold has-background-grey has-text-white">{{ moment(data_days_calendar[indexMain-1][5].dt).format('dddDD') }} 
            <span @click="contact_click(data_days_calendar[indexMain-1][5].dt)" v-if="contact_check(data_days_calendar[indexMain-1][5].dt)" class="icon mt-1 is-small is-pulled-right has-text-warning has-tooltip-left has-tooltip-warning" data-tooltip="Send Message"><i class="fas fa-comment-alt"></i>&nbsp;&nbsp;</span>
        </div>

<div @click="payment_click(s_data.student_ID)" class="column is-12 isLink" v-for ="(s_data, index) in calendar_load_day(data_days_calendar[indexMain-1][5].dt)" :key="index">
    <div class="columns is-gapless colBorderBottomThin">
        <div class="column is-8 has-background-white is-size-7 has-text-weight-bold is-uppercase">&nbsp;{{s_data.student_lNAME}} <span class="doFontSmallest"> {{s_data.student_fNAME}} </span></div>
        <div class="column is-4 is-size-7 has-text-right has-text-weight-bold" :style="return_style_calendar_item(s_data.payment_Rec,s_data.payment_DueDate)">{{format_money(s_data.payment_Amount,'$')}} &nbsp;</div>
    </div>
</div>

    </div>
</div>

<div class="column is-1">
    <div class="columns is-gapless is-multiline">
        <div class="column is-12 colBorderThinRight has-text-centered has-text-weight-bold has-background-grey has-text-white">{{ moment(data_days_calendar[indexMain-1][6].dt).format('dddDD') }} 
            <span @click="contact_click(data_days_calendar[indexMain-1][6].dt)" v-if="contact_check(data_days_calendar[indexMain-1][6].dt)" class="icon mt-1 is-small is-pulled-right has-text-warning has-tooltip-left has-tooltip-warning" data-tooltip="Send Message"><i class="fas fa-comment-alt"></i>&nbsp;&nbsp;</span>
        </div>

<div @click="payment_click(s_data.student_ID)" class="column is-12 isLink" v-for ="(s_data, index) in calendar_load_day(data_days_calendar[indexMain-1][6].dt)" :key="index">
    <div class="columns is-gapless colBorderBottomThin">
        <div class="column is-8 has-background-white is-size-7 has-text-weight-bold is-uppercase">&nbsp;{{s_data.student_lNAME}} <span class="doFontSmallest"> {{s_data.student_fNAME}} </span></div>
        <div class="column is-4 is-size-7 has-text-right has-text-weight-bold" :style="return_style_calendar_item(s_data.payment_Rec,s_data.payment_DueDate)">{{format_money(s_data.payment_Amount,'$')}} &nbsp;</div>
    </div>
</div>

    </div>
</div>






</div></div> 

</div>



<!-- <div v-if="paiment_view=='CALENDAR'" class="columns is-multiline is-gapless has-background-grey-light" style="margin-top:-1.6em;">
<div  :class="return_column_size(data)" class="mb-4" v-for ="(data, index) in sched_days" :key="index">

    <div class="columns is-gapless colBorder"  style="margin-bottom:0em;">
        <div class="column is-4 is-size-7 has-text-left has-text-dark has-text-weight-bold">
            &nbsp;&nbsp;{{moment(data).format('ddd')}}
        </div>
        <div class="column is-8 has-text-right has-text-dark has-text-weight-bold">
            {{moment(data).format('MMMDD')}}&nbsp;&nbsp;
        </div>
    </div>

    <div @click="payment_click(s_data.student_ID)" class="columns isLink is-multiline is-gapless" style="margin-bottom:0em;" v-for ="(s_data, index) in calendar_load_day(data)" :key="index">

    <div class="column has-background-white is-8 is-size-7 has-text-weight-bold is-uppercase">   
        {{s_data.student_lNAME}} <span class="doFontSmallest"> {{s_data.student_fNAME}} </span>
    </div>

<div class="column is-4 is-size-7 has-text-right has-text-weight-bold" :style="return_style_calendar_item(s_data.payment_Rec,s_data.payment_DueDate)">{{format_money(s_data.payment_Amount,'$')}} &nbsp;</div>

    </div>
</div></div> -->
<!-- ************************************ END CALENDAR ******************************************   style="margin-top:-.5em;"-->
</div>
 <!-- BEGIN LIST DATA !!!!  -->
<div v-if="paiment_view=='LIST'" class="columns is-centered is-multiline is-gapless">
<div class="column is-9">

<div class="columns is-gapless is-size-7 has-text-weight-bold" style="margin-bottom:0em;">
    <div class="column is-2">STUDENT</div>
    <div class="column is-2 has-text-right">DATE DUE</div>
    <div class="column is-1 has-text-right">AMOUNT</div>
    <div class="column is-1"></div>
    <div class="column is-1 has-text-right">OWE</div>
    <div class="column is-1 has-text-right">PAY</div>
    <div class="column is-1 has-text-right">SOLDE</div>
</div>



<div @click="payment_click(data.student_ID)" style="margin-bottom:0em;padding-top:.5em;padding-bottom:.5em;" class="columns colBorderThin isLink is-gapless" v-for ="(data, index) in sched_data" :key="index">
    <div class="column is-2">&nbsp;{{data.student_lNAME}}, {{data.student_fNAME}}</div>
    <div class="column is-2 has-text-right">{{ data.payment_DueDate | moment("add", "1 days","ddd MMM-D-YY")}}&nbsp;&nbsp;&nbsp;&nbsp;</div>
    <div class="column is-1 has-text-right" :style="return_style_calendar_item(data.payment_Rec,data.payment_DueDate)">{{format_money(data.payment_Amount,'$')}} &nbsp;</div>

    <div class="column is-1"></div>

    <div class="column is-1 has-text-right">{{format_money(data.student_frais_owe,'$')}} &nbsp;</div>
    <div class="column is-1 has-text-right">{{format_money(data.student_frais_pay,'$')}} &nbsp;</div>
    <div class="column is-1 has-text-right">{{format_money(data.student_frais_solde,'$')}} &nbsp;</div>



</div>
<!-- END LOOP  -->
</div> <!-- END COL MAIN  -->
</div>
<!-- ************************************ END LIST ******************************************  -->


 <!-- BEGIN IMPOT DATA !!!!  -->
<div v-if="paiment_view=='IMPOT'">

<div class="columns is-centered is-multiline is-gapless " v-for ="(data, index) in impot_data_studs" :key="index" style="margin-bottom:0em;">

<div class="column is-12" style="border-bottom: 5px dashed gray;">
<StudentTaxes
:data="data" :data_tax="impot_filter_stud_tax(data.student_ID)" :impot_year="impot_year" :key="data.student_ID"
@emit_impot_change="emit_impot_change"
@emit_impot_show_payments="emit_impot_show_payments"
> </StudentTaxes>
</div>


</div>

</div>
<!-- END IMPOT VIEW  -->


</div> </div>
<!-- MAIN CONTENT  -->

</div>
</template>


<script>
import axios from 'axios';
import moment from 'moment';
import PaymentsStudent  from '@/components/Comp_Student_Pay_II';
import StudentTaxes  from '@/components/Comp_Student_Taxes';



import eachDayOfInterval from 'date-fns/eachDayOfInterval'
import isWeekend from 'date-fns/isWeekend'
import getMonth from 'date-fns/getMonth'

import Contact from '@/components/Comp_Contact'

export default {
        props: [],
        components: { PaymentsStudent , StudentTaxes, Contact},

        data() {
            return {
                isLoading:false,
                navOpen:false,
                search:'',
                dtStart:moment().subtract(7,'days').format('YYYY-MM-DD'),
                dtEnd:moment().add(14,'days').format('YYYY-MM-DD'),
                show_dt_change : false,

paiment_view: 'CALENDAR',
data_paiments:[],
pay_total : 0,
pay_recu : 0,
pay_solde : 0,

sched_days:[], // -- GONE
data_days_calendar:[],

sched_data:[],

student_id:'',

data_filter_etud:[], 
filter_etud:'',
data_filter_grp:[],
filter_grp:'',
// data_filter_grp:[],

// ---- PAGING ----
page_offset: 0,
page_count: 50,
page_max: 0,
page_string:'',

impot_search: '',
impot_year:2021,
impot_data_studs_temp:[], // HOLD SO NO LOAD
impot_data_studs:[],
impot_data_tax:[],
impot_sql:'',

impot_head_cnt:0,
impot_head_amt:0,
impot_head_cnt_select:0,
impot_head_amt_qc:0,
impot_head_amt_can:0,


impot_order_desc:'student_lNAME',
impot_order_order:'ASC',

data_contact: [],

    config: { // FLATPICKER
        altFormat: "M j, y",
        altInput: true,
        disableMobile: true
    },

            }
        },


  computed: {

  },

mounted() {
    setTimeout(() => { this.get_paiement_info() ;  this.openNav(); }, 500);

},


created() {



}, // END CREATED!

methods : {

contact_check:function(key) {

    var bReturn = false
    for (var i = 0; i < this.sched_data.length; i++) {
        if (this.sched_data[i].payment_DueDate.substring(0,10) == key)
        {bReturn =  true ; break;} 
    }

    return bReturn
},
// END CHECK IF HAS COURSE -- SHOW CONTACT BUTTON
contact_click:function(key) {
    var query = `SELECT DISTINCT MyMEQ_STUDENT.student_ID, MyMEQ_STUDENT.prog_ID, MyMEQ_STUDENT.student_GRPCODE, MyMEQ_STUDENT.student_fNAME, MyMEQ_STUDENT.student_lNAME, MyMEQ_STUDENT.student_eMail, MyMEQ_STUDENT.student_TelHome
    , 1 AS goodToGo FROM MyMEQ_STUDENT INNER JOIN MyMEQ_STUDENT_PAYMENT ON MyMEQ_STUDENT.student_ID = MyMEQ_STUDENT_PAYMENT.student_ID
    WHERE (payment_DueDate = '` + key + `') ORDER BY student_lNAME`
    axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
    .then(res => { 
        this.data_contact = res.data
        document.querySelector('#myModalContact').classList.add('is-active');
    });

},
// END CONTACT CLICK ----
close_contact_modal:function(isSent) {
    document.querySelector('#myModalContact').classList.remove('is-active');
    if (isSent==true) {
        this.$snotify.success(' SENT !!', {
            timeout: 500,showProgressBar: true,closeOnClick: false,pauseOnHover: false
        }); 
    }
},


// LOAD PAIMENTS !!
get_paiement_info:function() {
// GET ALL PAIMENTS AND TOTALS FOR DATE RANGE 

    // sessionStorage.setItem('pay_date_start', this.dtStart)
    // sessionStorage.setItem('pay_date_end', this.dtEnd)

this.show_dt_change = false 
this.data_days_calendar = []

this.isLoading=true;
var query = `SELECT SUM(payment_Amount) AS amt, payment_Rec FROM MyMEQ_STUDENT_PAYMENT
WHERE (payment_Amount > 0) AND (payment_DueDate BETWEEN '` + this.dtStart + `' AND '` + this.dtEnd + `')
GROUP BY payment_Rec ORDER BY payment_Rec`
console.log(query)
axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
.then(res => { 
        if (!res.data[0]) { this.isLoading=false; return }

        if (res.data.length==2) {
            this.pay_solde = res.data[0].amt
            this.pay_recu = res.data[1].amt
        } else {
            if (res.data[0].payment_Rec == "1") {this.pay_recu = res.data[0].amt}
            else {this.pay_solde = res.data[0].amt}
        }
        this.pay_total = Number(this.pay_solde) + Number(this.pay_recu)


        var query = `SELECT MyMEQ_STUDENT_PAYMENT.payment_ID, MyMEQ_STUDENT_PAYMENT.student_ID, MyMEQ_STUDENT.student_lNAME, MyMEQ_STUDENT.student_fNAME, student_GRPCODE,
        MyMEQ_STUDENT_PAYMENT.payment_Number, MyMEQ_STUDENT_PAYMENT.payment_Amount, MyMEQ_STUDENT_PAYMENT.payment_DueDate, 
        MyMEQ_STUDENT_PAYMENT.payment_Rec, MyMEQ_STUDENT_PAYMENT.payment_RecDate, MyMEQ_STUDENT_PAYMENT.payment_Type  , student_frais_owe,student_frais_pay,student_frais_solde
        FROM  MyMEQ_STUDENT_PAYMENT INNER JOIN MyMEQ_STUDENT ON MyMEQ_STUDENT_PAYMENT.student_ID = MyMEQ_STUDENT.student_ID 
        WHERE (payment_Amount > 0) AND (MyMEQ_STUDENT_PAYMENT.payment_DueDate BETWEEN '` + this.dtStart + `' AND '` + this.dtEnd + `') 
        ORDER BY MyMEQ_STUDENT_PAYMENT.payment_DueDate,payment_Number`
        console.log(query)
        axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
.then(res => { 

    // this.switch_filter(this.paiment_filter)
    // //  = res.data


this.data_filter_etud=[] ; this.data_filter_grp=[] ;
if (res.data.length > 0) { //FOR FILTER

    //  this.data_filter_etud = [...new Set(res.data.map(item => item.student_ID))];
    for (var i = 0; i < res.data.length; i++) {
        var keyIndex = this.data_filter_etud.findIndex(x => x.student_ID === res.data[i].student_ID);    
        if (keyIndex==-1) {this.data_filter_etud.push(res.data[i])}
    }
    this.data_filter_grp = [...new Set(res.data.map(item => item.student_GRPCODE))];
    this.data_filter_grp.sort()
    this.data_filter_etud.sort((a, b) => a.student_lNAME.localeCompare(b.student_lNAME))
}

    var dS = moment(this.dtStart).startOf('isoWeek').format('YYYY-MM-DD')
    var dE = moment(this.dtEnd).add(7,'days').endOf('isoWeek').format('YYYY-MM-DD')


// FOR THE CALENDAR DAYS !
    var wks = moment(dE).diff(moment(dS),"weeks")
    var dtSt = dS

    for (var i = 0; i < wks; i++) {
        var dt = moment(dtSt).add((i*7),"days").format('YYYY-MM-DD')
        var dS = moment(dt).startOf('isoWeek').format('YYYY-MM-DD')
        var dE = moment(dt).endOf('isoWeek').format('YYYY-MM-DD')
        var temp = []
        while (dS <= dE) {
            var obj = {};
            obj.dt = moment(dS).format('YYYY-MM-DD')
            obj.val = ''
            temp.push(obj)
            dS = moment(dS).add(1,"days").format('YYYY-MM-DD')
        }
        this.data_days_calendar.push(temp);
    }
// END CALENDAR DAYS ---------------------








        // this.sched_days = eachDayOfInterval({
        //     start: new Date(dS),
        //     end: new Date(dE)
        // })

     this.data_paiments = res.data
     this.sched_data = res.data

    this.isLoading=false;
});  });  // END AXIOS

}, // END LOAD PAIEMENTS

calendar_load_day:function(dtIn) {
//this.isLoading=true;
var retData = [];
        var self = this;
        this.sched_data.forEach(function(item){
        if (item.payment_DueDate.substring(0,10) == moment(dtIn).format("YYYY-MM-DD")) {
                    var obj = {};
                    obj.student_ID= item.student_ID
                    obj.student_lNAME = item.student_lNAME
                    obj.student_fNAME = item.student_fNAME
                    obj.payment_Number = item.payment_Number
                    obj.payment_Amount = item.payment_Amount
                    obj.payment_Rec = item.payment_Rec
                    obj.payment_DueDate = item.payment_DueDate
                    obj.student_eMail = item.student_eMail
                    obj.student_TelHome = item.student_TelHome
                    obj.student_TelOther = item.student_TelOther
                    //obj.number = item.numberv payment_Number
                    retData.push(obj);
        } 
        }); // END FOR eACH
//this.isLoading=false;        
return retData;
}, // END SCHED LOAD DAY
return_style_calendar_item:function(rec, dtIn) {

    var retStyle = 'margin-bottom:0em;' 
    if (rec) { retStyle += 'background-color: ' + 'rgba(0, 255, 0, 0.2)' + ';' }
    else if (moment(dtIn).format('YYYY-MM-DD') < moment().format('YYYY-MM-DD') ) { retStyle += 'background-color: ' + 'rgba(255, 0, 0, 0.3)' + ';' }
    else {retStyle += 'background-color: ' + 'white' + ';'} 
    return retStyle

}, // END RETURN CALENDAR ITEM COLOUR

return_column_size:function(dtIN) {
// IF WEEKEND COL = 1

var retStyle = 'column colBorder'

    if (isWeekend(new Date(dtIN))) {retStyle += " is-1 "} else {retStyle += " is-2 "} // ENDIF
// hLight monthchange
    var mo = getMonth(new Date(dtIN))
    if (mo % 2 === 0)  {
        retStyle += " has-background-light "
    } else {
        retStyle += " has-background-light "
    } // ENDIF

return retStyle

}, // END COLUMN SIZE

return_week_number:function(dt) {
    return moment(dt, "MMDDYYYY").isoWeek();
},

payment_click:function(id) {

    this.student_id = id
    document.querySelector('#myModalPai').classList.add('is-active');

}, // END PAY CLICK
modal_close:function(doUpdate) {
    document.querySelector('#myModalPai').classList.remove('is-active');
    this.student_id = null
  },

format_money:function (n, currency) {
    try {return currency + parseFloat(n).toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");}
    catch(err) {return '-' }
},
return_date:function(dt) {
    return moment(dt).format("MMM DD YY")
},

sortNav() {
    if (this.navOpen) {this.closeNav()} else {this.openNav()}
},
openNav() {
  document.getElementById("mySidebar").style.width = "300px";
  document.getElementById("mainContent").style.marginLeft = "300px";
  this.navOpen = true;
  this.new_show= false;
},
/* Set the width of the sidebar to 0 and the left margin of the page content to 0 */
closeNav() {  
  document.getElementById("mySidebar").style.width = "0";
  document.getElementById("mainContent").style.marginLeft = "0";
  this.navOpen = false;
},

// GENERATE A NEW ID! 
randomKey:function() {
return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
});},



// IMPOT *******************************************************
impot_go:function() {
    this.paiment_view='IMPOT'
    this.impot_load()
},
impot_filter_stud_tax:function(stud_id) {
// FILTER BEFORE SENDING TO COMP.
    const aTax = this.impot_data_tax.filter((s) => s.student_ID === stud_id)
    return aTax
},

doSynchronousLoop:function(data, processData, done) {
    if (data.length > 0) {
        var loop = function(data, i, processData, done) {
            processData(data[i], i, function() {
                if (++i < data.length) {  setTimeout(function(){ loop(data, i, processData, done);  }, 0);
                } else {    done();    }  });  };
        loop(data, 0, processData, done); } else { done(); }
},


impot_search_clear:function() {
    this.impot_search = ''
    this.impot_load()
},

impot_load:function(doHeader) {
this.isLoading=true;

var sWhere = ''
if (this.impot_search != '') {
    sWhere = " AND ((student_GRPCODE LIKE '" + this.impot_search + "%25') " 
    sWhere += " OR (student_lNAME LIKE '" + this.impot_search + "%25') " 
    sWhere += " OR (student_CodePerm LIKE '" + this.impot_search + "%25')) "
}


var orderIt = ' ORDER BY ' + this.impot_order_desc + ' ' + this.impot_order_order
var query = `SELECT  DISTINCT 
MyMEQ_STUDENT.student_ID, MyMEQ_STUDENT.student_lNAME, MyMEQ_STUDENT.student_fNAME, MyMEQ_STUDENT.student_frais_owe, 
MyMEQ_STUDENT.student_frais_pay, MyMEQ_STUDENT.student_frais_solde, SUM(MyMEQ_STUDENT_PAYMENT.payment_Amount) AS amt, 
MyMEQ_STUDENT.student_GRPCODE, MyMEQ_STUDENT.student_CreateDate, MyMEQ_STUDENT.student_EndDate, MyMEQ_STUDENT.student_blnComplete
,student_SIN, student_CodePerm, student_NumAdmission, 0 AS hrs_total, 0 AS hrs_can_1, 0 AS hrs_can_2, 0 AS hrs_can_3, 0 AS hrs_can_4   FROM            MyMEQ_STUDENT INNER JOIN
MyMEQ_STUDENT_PAYMENT ON MyMEQ_STUDENT.student_ID = MyMEQ_STUDENT_PAYMENT.student_ID
WHERE        (MyMEQ_STUDENT_PAYMENT.payment_RecDate BETWEEN '` + this.impot_year + `-01-01' AND '` + this.impot_year + `-12-31')
` + sWhere + `
GROUP BY MyMEQ_STUDENT.student_ID, MyMEQ_STUDENT.student_lNAME, MyMEQ_STUDENT.student_frais_owe, MyMEQ_STUDENT.student_frais_pay, MyMEQ_STUDENT.student_frais_solde, MyMEQ_STUDENT.student_fNAME, MyMEQ_STUDENT.student_GRPCODE, MyMEQ_STUDENT.student_CreateDate, 
MyMEQ_STUDENT.student_EndDate, MyMEQ_STUDENT.student_blnComplete,student_SIN, student_CodePerm, student_NumAdmission ` + orderIt
 query +=   ` OFFSET ` + this.page_offset + ` ROWS FETCH NEXT ` + this.page_count + ` ROWS ONLY`

console.log(query)


axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
.then(res => {
    this.impot_data_studs_temp = res.data // PUT IN TEMP SO DOESN'T LOAD YET !

// GET THE TaX INFO
var query = `SELECT * FROM myMEQ_STUDENT_TAX WHERE studTax_YEAR = 2020`
axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
.then(res => {
    this.impot_data_tax = res.data
    
    var query = `SELECT COUNT(DISTINCT MyMEQ_STUDENT.student_ID) AS cnt, SUM(payment_Amount) AS amt FROM MyMEQ_STUDENT INNER JOIN MyMEQ_STUDENT_PAYMENT ON MyMEQ_STUDENT.student_ID = MyMEQ_STUDENT_PAYMENT.student_ID
    WHERE (payment_RecDate BETWEEN '` + this.impot_year + `-01-01' AND '` + this.impot_year + `-12-31') ` + sWhere  

    axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
    .then(res => {
    this.impot_head_cnt = res.data[0].cnt
    this.impot_head_amt = res.data[0].amt

// CHECK IF NEeD TO SET PAGE ....
 if (doHeader || sWhere != '') {
    this.check_pagination(res.data[0].cnt)
 }

var query = `SELECT COUNT(DISTINCT MyMEQ_STUDENT.student_ID) AS cnt, SUM(studTax_QC_AMT) AS amt_qc, SUM(studTax_CAN_AMT) AS amt_can FROM MyMEQ_STUDENT INNER JOIN myMEQ_STUDENT_TAX ON MyMEQ_STUDENT.student_ID = myMEQ_STUDENT_TAX.student_ID ` 
if (sWhere != '') {query += sWhere}


    axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
    .then(res => {
        this.impot_head_cnt_select = res.data[0].cnt
        if (this.impot_head_cnt_select > 0) {
            this.impot_head_amt_qc = res.data[0].amt_qc
            this.impot_head_amt_can = res.data[0].amt_can
        } else {
            this.impot_head_amt_qc = 0
            this.impot_head_amt_can = 0            
        }

    this.isLoading=false;
    this.impot_tax_start()
});  });

});  });

},

impot_tax_start:function() {

    this.isLoading=true;
    this.impot_sql = ''
    this.doSynchronousLoop(this.impot_data_studs_temp,this.impot_tax_do, this.impot_tax_done)
},

impot_tax_do:function(item, i, callback) {
    

    this.impot_sql += " ((MyMEQ_COURSESTUDENT.student_ID = " + item.student_ID + ") AND (MyMEQ_GROUP.group_ANN = '21')) OR "
    callback()

},
impot_tax_done:function() {
   
this.impot_sql = this.impot_sql.substring(0, this.impot_sql.length-3)
var query = `SELECT MyMEQ_COURSESTUDENT.student_ID, MyMEQ_GROUP.group_SESS, SUM(MyMEQ_COUR.cour_HOURS) AS hrs FROM MyMEQ_COURSESTUDENT INNER JOIN MyMEQ_GROUP ON MyMEQ_COURSESTUDENT.group_ID = MyMEQ_GROUP.group_ID INNER JOIN MyMEQ_COUR ON MyMEQ_GROUP.cour_ID = MyMEQ_COUR.cour_ID
WHERE ` + this.impot_sql + ` GROUP BY MyMEQ_COURSESTUDENT.student_ID, MyMEQ_GROUP.group_SESS`

console.log('----')
console.log(query)

axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
.then(res => {
    var data_temp = res.data
     
// CHECK IF NOTHING
if (data_temp.length==0) {return}


for (var x=0; x < this.impot_data_studs_temp.length; x++) {  
    
        const aHrs = data_temp.filter((s) => s.student_ID === this.impot_data_studs_temp[x].student_ID)
        var hrsTotal = 0

        for (var i = 0; i < aHrs.length; i++) {
            hrsTotal = Number(hrsTotal) + Number(aHrs[i].hrs)

if (aHrs[i].group_SESS == 'H') {this.impot_data_studs_temp[x].hrs_can_1 = aHrs[i].hrs}
if (aHrs[i].group_SESS == 'E') {this.impot_data_studs_temp[x].hrs_can_2 = aHrs[i].hrs}
if (aHrs[i].group_SESS == 'A') {this.impot_data_studs_temp[x].hrs_can_3 = aHrs[i].hrs}

        }

    this.impot_data_studs_temp[x].hrs_total = hrsTotal

}

    this.isLoading=false;
    this.impot_data_studs = this.impot_data_studs_temp // LOAD THE DATA !!!!
});


},








}, // END METHODS


}
</script>

<style scoped>

</style>